/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdBookmarksFolders200Ok
 */
export interface GetCharactersCharacterIdBookmarksFolders200Ok {
    /**
     * folder_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarksFolders200Ok
     */
    folderId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetCharactersCharacterIdBookmarksFolders200Ok
     */
    name: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdBookmarksFolders200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdBookmarksFolders200Ok(value: object): value is GetCharactersCharacterIdBookmarksFolders200Ok {
    if (!('folderId' in value) || value['folderId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdBookmarksFolders200OkFromJSON(json: any): GetCharactersCharacterIdBookmarksFolders200Ok {
    return GetCharactersCharacterIdBookmarksFolders200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarksFolders200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdBookmarksFolders200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'folderId': json['folder_id'],
        'name': json['name'],
    };
}

export function GetCharactersCharacterIdBookmarksFolders200OkToJSON(json: any): GetCharactersCharacterIdBookmarksFolders200Ok {
    return GetCharactersCharacterIdBookmarksFolders200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarksFolders200OkToJSONTyped(value?: GetCharactersCharacterIdBookmarksFolders200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'folder_id': value['folderId'],
        'name': value['name'],
    };
}

